import { notification, message } from 'ant-design-vue'
import { TOKEN } from '@/store/mutation-types'
import Vue from 'vue'
import { throttle, getExpandTime } from '@/utils/util'
import store from '@/store/index'
import router from '@/router'
import Cookies from 'js-cookie'
import { isLocal, apiKey } from '@/api/url'
const errorMsg = '网络异常，请稍后重试'

const expandTime = getExpandTime()

/**
 * 请求成功拦截器，在拦截器里添加需要处理：
 * 根据需要携带对应的 accessToken
 * @param request 原始请求
 */
function requestSuccess(request: any) {
	if (!Vue.ss.get('expandTime')) {
		// 延长太久不操作登出的时间
		expandTime()
	}

	request.headers.originType = 'PC'
	const tempToken = Vue.ss.get('token')
	if (tempToken) {
		Cookies.set('token', tempToken, { domain: 'cias.cn' })
	}

	request.baseURL = apiKey

	// 配合vue.config使用
	// if (isLocal) {
	// 	if (request.url.startsWith('media')) {
	// 		request.baseURL = apiKey
	// 	} else {
	// 		request.baseURL = '/local'
	// 	}
	// }
	return request
}

/**
 * 请求失败拦截器,处理常见的请求失败
 * @param error 请求错误
 */
function requestFail(error: any) {
	return Promise.reject(error)
}

const throttle2s = throttle(2000)

/**
 * 响应成功拦截器
 * @param response 响应
 */
function responseSuccess(response: any) {
	const data = response.data
	if (response.headers['content-disposition'] && response.headers.location) {
		return {
			data,
			filename: decodeURIComponent(response.headers.location),
		}
	}
	if (data && ![0, 200, 409].includes(data.code)) {
		if (response.data instanceof Blob) {
			return new Promise((resolve, reject) => {
				const blob = response.data
				var reader = new FileReader()
				reader.onload = (e: any) => {
					try {
						const json = JSON.parse(e.target.result)
						if (json.code !== 200) {
							message.error(json.message || errorMsg)
						}
						reject(json)
					} catch (err) {
						// JSON.parse抛出异常，此时应为文件内容 返回Blob
						reject(response.data)
					}
				}
				reader.readAsText(blob)
			})
		} else {
			message.error(response.data.message || errorMsg)
			if (
				response.config.url == '/injury/user/oauth/ding/login' &&
				response.data.code !== 200
			) {
				setTimeout(() => {
					window.location.replace(`${location.origin}/passport/login`)
				}, 2000)
			}
		}
		if (response.data.code === 401) {
			throttle2s(() => {
				store.dispatch('user/Logout').then(() => {
					setTimeout(() => {
						window.location.replace(`${location.origin}/passport/login`)
					}, 3000)
				})
			})
		}
		return Promise.reject(response.data)
	}
	return response.data
}

function responseFail(error: any) {
	if (error.response) {
		const data = error.response.data
		if ([401, 403, 406].includes(data.code)) {
			const msg: string = data.message || errorMsg
			let redirect = data.data.redirect
			redirect = redirect.replace(/^http\S+cias.cn/, location.origin)
			if (store.getters.roles.length !== 0) {
				message.error(msg)
				setTimeout(() => {
					window.location.replace(`${redirect}&redirect_url=${location.origin}`)
				}, 3000)
			}
		} else {
			let msg = ''
			msg += error.message
			if (error.config) {
				msg += `, ${location.origin}${error.config.url}`
			}
			message.error(msg)
		}
	} else {
		message.error(errorMsg)
	}
	return Promise.reject(error)
}

export default {
	requestSuccess,
	requestFail,
	responseSuccess,
	responseFail,
}
